

import cs from './index.module.css'
import {Button} from "@/components/ui/button.tsx";

export default function InertiaExample() {
  return (
    <div className={cs.root}>
      <Button>KJkkadsjkd</Button>
    </div>
  )
}
